import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/information-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-220cecd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-panel-container" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  style: {"margin-right":"5px","white-space":"nowrap"},
  "data-test": "dp-title"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "information",
  "data-test": "dp-tooltip-icon"
}, null, -1))
const _hoisted_5 = ["href", "target"]
const _hoisted_6 = { class: "center-flex panel-slot-container" }

import { Tooltip } from "uiv";


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-panel',
  props: {
    title: {},
    href: { default: "" },
    target: { default: "_self" },
    isClickable: { type: Boolean, default: true },
    tooltipText: { default: null }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.tooltipText)
        ? (_openBlock(), _createBlock(_unref(Tooltip), {
            key: 0,
            text: _ctx.tooltipText,
            class: "information-tooltip",
            "data-test": "dp-tooltip"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("a", {
      href: _ctx.isClickable ? _ctx.href : 'javascript:void(0)',
      target: _ctx.isClickable ? _ctx.target : '_self',
      style: _normalizeStyle({ cursor: _ctx.isClickable ? 'pointer' : 'not-allowed' }),
      "data-test": "dp-router-link"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["panel report-tile panel-default text-center tile-shadow", { 'no-scale': !_ctx.isClickable }])
      }, [
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2)
    ], 12, _hoisted_5)
  ]))
}
}

})